import { QuickChartData } from "../types";
import { Remirror as RemirrorTypes } from '../../';

type RootNode = RemirrorTypes.RootNode;
const NodeType = RemirrorTypes.NodeType;

export function setInsightsDataUtil(chartData: QuickChartData): RootNode | null {
  if (chartData.insights) {
    try {
      return JSON.parse(chartData.insights) as RootNode;
    } catch {
      // If insights is a plain string, create a simple document structure
      return {
        type: NodeType.Doc,
        content: [
          {
            type: NodeType.Paragraph,
            content: [{ type: NodeType.Text, text: chartData.insights }],
          },
        ],
      };
    }
  }
  return null;
}